export const GET_PURCHASES_REQUEST = "GET_PURCHASES_REQUEST"
export const GET_PURCHASES_SUCCESS = "GET_PURCHASES_SUCCESS"
export const GET_PURCHASES_FAILURE = "GET_PURCHASES_FAILURE"
export const GET_NEXT_PAGE_PURCHASES_REQUEST = "GET_NEXT_PAGE_PURCHASES_REQUEST"
